export default __webpack_public_path__ + "static/media/PMI.0e044017.png";